"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgTick = function SvgTick(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 29 28",
    fill: "none"
  }, props), {}, {
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsx)("defs", {
      children: (0, _jsxRuntime.jsx)("path", {
        id: "tick_svg__a",
        d: "M0 0h26v26H0z"
      })
    }), (0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [(0, _jsxRuntime.jsx)("path", {
        fill: "#CCEFF1",
        d: "M24 16c0 6.628-5.372 12-12 12S0 22.628 0 16C0 9.373 5.373 4 12 4s12 5.373 12 12"
      }), (0, _jsxRuntime.jsxs)("g", {
        transform: "translate(2)",
        children: [(0, _jsxRuntime.jsx)("mask", {
          id: "tick_svg__b",
          fill: "#fff",
          children: (0, _jsxRuntime.jsx)("use", {
            xlinkHref: "#tick_svg__a"
          })
        }), (0, _jsxRuntime.jsx)("path", {
          fill: "#00AEB8",
          d: "M13 2C6.937 2 2 6.934 2 13c0 6.064 4.936 11 11 11 6.066 0 11-4.936 11-11 0-6.066-4.934-11-11-11m0 24C5.833 26 0 20.167 0 13S5.833 0 13 0c7.169 0 13 5.832 13 13s-5.83 13-13 13",
          mask: "url(#tick_svg__b)"
        })]
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#00AEB8",
        d: "M13.409 17.183a.996.996 0 01-.707-.293L9.52 13.707a1 1 0 011.414-1.414l2.475 2.476 5.657-5.657a.999.999 0 111.414 1.414l-6.364 6.364a.996.996 0 01-.707.293"
      })]
    })]
  }));
};

var _default = SvgTick;
exports["default"] = _default;